import SelectorObserver from '../lib/SelectorObserver';

(function iife(tarteaucitron) {

    if (!tarteaucitron) {
        return;
    }

    tarteaucitron.services.rdlv_youtube = {
        "key": "rdlv_youtube",
        "type": "video",
        "name": "YouTube",
        "uri": "https://www.google.fr/intl/fr/policies/privacy/",
        "needConsent": true,
        "cookies": ['VISITOR_INFO1_LIVE', 'YSC', 'PREF', 'GEUP'],
        "js": function () {
            "use strict";
            tarteaucitron.fallback(['youtube_player'], function (node) {
                const html = node.getAttribute('data-tac-html');
                node.removeAttribute('style');
                // do not remove in case this is called multiple times
                // node.removeAttribute('data-tac-html');
                return html;
            });
        },
        "fallback": function () {
            "use strict";
            var id = 'rdlv_youtube';
            tarteaucitron.fallback(['youtube_player'], function () {
                return tarteaucitron.engage(id);
            });
        }
    };

    const selector = 'iframe[data-provider="youtube"][src*="enablejsapi=1"]';
    const so = new SelectorObserver(selector);
    so.listen('added', function initApi() {
        so.unlisten('added', initApi);

        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);

        window.onYouTubeIframeAPIReady = function () {
            document.querySelectorAll(selector).forEach(initPlayer);
            so.listen('added', initPlayer);
        };
    });

    function initPlayer(iframe) {
        // event types: window.YT.PlayerStase
        iframe.player = new window.YT.Player(iframe);
    }
})(window.tarteaucitron);